import 'normalize.css'
import '@/assets/index.scss'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import { Button, ConfigProvider, Icon, Toast } from 'vant'
import appHost, { isAndrod, isIos, initBaseGlobalHeaderInfo } from '@/utils/app'
import wxHost from '@/utils/wx'
import { ENTRYQUERYINFOKEY } from '@/config/constant'
import { IClients } from './types/client'
import { setGlobelHeader } from '@/utils/request'
import { getValueBySearch, getQueryStringArgs } from '@/utils/index'
import { initWatchMessage } from '@/compositions/useCustomWindowApi'
import { setStorage, getStorage } from '@/utils'
import { MINIKEY } from '@/config/constant'
import { userEntryUrlStorage } from '@/storage/common'
// import VConsole from 'vconsole'

// new VConsole()
try {
  // 如果是在小程序下跑的，说明是哪个小程序下跑的 mini=menber 说明是 极飞服务下跑的
  const miniResultFromStorage = getStorage<string>(MINIKEY, window.sessionStorage)
  const miniResultFromSearch = getValueBySearch(window.location.search || '', 'mini')
  let isMiniProgram = false
  if (miniResultFromSearch || miniResultFromStorage) {
    const miniResult = miniResultFromSearch || miniResultFromStorage
    wxHost._isMockMiniprogram = true
    setGlobelHeader('mini', miniResult)
    setStorage(MINIKEY, miniResult, window.sessionStorage)
    store.commit('setClient', IClients.miniProgram)
    isMiniProgram = true
  }
  initBaseGlobalHeaderInfo()
} catch (error) {
  console.log('', error)
}

if (isAndrod || isIos) {
  isAndrod && store.commit('setClient', IClients.android)
  isIos && store.commit('setClient', IClients.ios)
}

setStorage(ENTRYQUERYINFOKEY, getQueryStringArgs(location.href), sessionStorage)
try {
  // getStatusBarHeight用于页面顶部状态栏的适配，如果没有注入将会导致适配有问题
  appHost.getStatusBarHeight((px: number) => {
    /** IOS 都是按照两倍分辨率来给  */
    const devicePixelRatio = window.devicePixelRatio
    store.commit('setAppStatusBarHeight', px / devicePixelRatio)
    store.commit('setAppStatusBarHeightOrigin', px)
  })
  // startLocation  用于获取经纬度，部分功能可能无需使用， 原生也不会注入
  // 监管要求，不再进入就获取经纬度，只在使用的时候获取
  // appHost.startLocation(true, (lng: number, lat: number) => {
  //   store.commit('setUserSite', [parseFloat(lng.toString()), parseFloat(lat.toString())])
  // })
  userEntryUrlStorage.set(window.location.href.split('#')[0])
  // 目前无网的业务只兼容于打开网页阶段，如果网页已经加载，后续无网状态不处理
  // 告知app当前页面已加载啊1
  appHost.setOfflinePageEnable(false)
} catch (error) {
  console.log('error', error)
}
window.isInIframe = window.frames.length !== parent.frames.length
initWatchMessage()
// Toast.setDefaultOptions({ duration: 3000 })
createApp(App)
  .use(store)
  .use(Button)
  .use(ConfigProvider)
  .use(Icon)
  .use(Toast)
  .use(router)
  .mount('#app')
